import Carousel from '@stimulus-components/carousel'
import Swiper from 'swiper'

export default class CarouselStimulusController extends Carousel {
  static values = {
    slidesPerView: Number,
  };

  static targets = [
    'swiperPagination',
    'swiperButtonPrev',
    'swiperButtonNext',
  ];

  connect() {
    this.initCarousel();
  }

  initCarousel() {
    let navigationOptions = false;
    let paginationOptions = false;

    if (this.hasSwiperButtonNextTarget && this.hasSwiperButtonPrevTarget) {
      navigationOptions = {
        nextEl: this.swiperButtonNextTarget,
        prevEl: this.swiperButtonPrevTarget,
      }
    }

    if (this.hasSwiperPaginationTarget) {
      paginationOptions = {
        el: this.swiperPaginationTarget,
        type: 'bullets',
        clickable: true,
      }
    }

    this.swiper = new Swiper(this.element, {
      loop: true,
      slidesPerView: this.slidesPerViewValue,
      spaceBetween: 4,
      navigation: navigationOptions,
      pagination: paginationOptions,
      threshold: 0,
    });
  }
}
